import {easeInOutQuad} from 'easings.js';
import scrrroll from 'scrrroll';

scrrroll.duration = 1000;
scrrroll.easing = easeInOutQuad;

export default function(dom, opts) {
	let options = {
		...opts
	};

	const href = dom.getAttribute('href');
	let target;

	if (options.selector) {
		target = document.querySelector(options.selector);
	}
	else if (href && /^#/.test(href)) {
		target = document.querySelector(href);

		if (!target) {
			target = document.querySelector(`[name="${href.substring(1)}"]`);
		}
	}
	else if (options.to) {
		let from = dom;

		if (options.parent) {
			from = dom.closest(options.parent);
		}

		if (options.to == 'previous') {
			target = from.previousElementSibling;
		}
		else {
			target = from.nextElementSibling;
		}
	}

	dom.addEventListener('click', async e => {
		e.preventDefault();

		if (options.top) {
			scrrroll.toTop();
		}
		else if (options.bottom) {
			scrrroll.toBottom();
		}
		else if (target) {
			await scrrroll.to(target);
			if (href) {
				location.hash = href;
			}
		}
	});
}
